exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".stars[data-v-09acf378]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;color:#04be02}.stars .star+.star[data-v-09acf378]{margin-left:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09acf378","scoped":true,"hasInlineConfig":false}!./node_modules/_less-loader@4.0.5@less-loader/dist/cjs.js!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/stars/index.vue
// module id = Wju7
// module chunks = 1